import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "contact",
  class: "screen secondary"
}
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "wrapper" }
const _hoisted_4 = {
  key: 0,
  class: "panel success"
}
const _hoisted_5 = { class: "icon" }
const _hoisted_6 = {
  key: 1,
  class: "panel grid-2 contact"
}
const _hoisted_7 = {
  key: 0,
  class: "error"
}
const _hoisted_8 = {
  key: 1,
  class: "error"
}
const _hoisted_9 = { class: "actions" }

import CommonShapeAnimation from "@/components/common/CommonShapeAnimation.vue";
import CommonButton from "@/components/common/CommonButton.vue";
import CommonInput from "@/components/common/CommonInput.vue";

import IconComplete from "@/components/icons/IconComplete.vue";
import IconMessages from "@/components/icons/IconMessages.vue";

import { trackFormSubmit } from "@/helpers/analytics.helper";
import { SpamDetectionHelper } from "@/helpers/spam-detection.helper";

import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SectionContact',
  setup(__props) {

const messageSending = ref(false);
const messageSent = ref(false);
const messageError = ref(false);
const validationErrors = ref<{ [key: string]: string[] }>({});

const name = ref("");
const email = ref("");
const message = ref("");
const honeypot = ref("");

const submit = async (event: Event) => {
    event.preventDefault();
    event.stopPropagation();

    messageError.value = false;
    validationErrors.value = {};

    const spamValidation = SpamDetectionHelper.validateContactForm({
        name: name.value,
        email: email.value,
        message: message.value
    });

    if(!spamValidation.isValid) {
        validationErrors.value = spamValidation.errors;
        return;
    }
    if(honeypot.value.trim() !== '') {
        messageError.value = true;
        return;
    }

    messageSending.value = true;

    try {
        const body = {
            name: name.value,
            email: email.value,
            message: message.value,
            honeypot: honeypot.value
        };
        
        const request = await fetch(`${process.env.VUE_APP_API_BASEURL}/mail/contact`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Origin': process.env.VUE_APP_BASEURL
            },
            body: JSON.stringify(body)
        });

        messageSending.value = false;
        
        if(!request.ok) {
            if(request.status === 400) {
                const errorData = await request.json();
                if(errorData.errors) {
                    console.error('Validation errors:', errorData.errors);
                }
            }
            trackFormSubmit("contact");
            messageError.value = true;
            return;
        }
        
        messageSent.value = true;
        trackFormSubmit("contact");

    }catch (error) {
        console.error(error);
        messageSending.value = false;
        messageError.value = true;
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(CommonShapeAnimation, {
      shape: "polygon",
      sides: 7,
      rotation: 5,
      position: "left"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (messageSent.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(IconComplete)
              ]),
              _cache[4] || (_cache[4] = _createElementVNode("div", null, [
                _createElementVNode("h3", null, "Votre message à bien été envoyé !"),
                _createElementVNode("p", null, "Nous vous contacterons très prochainement.")
              ], -1))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", null, [
                _createElementVNode("header", null, [
                  _createVNode(IconMessages),
                  _cache[5] || (_cache[5] = _createElementVNode("h3", null, "Nous contacter", -1))
                ]),
                _cache[7] || (_cache[7] = _createElementVNode("p", null, [
                  _createElementVNode("strong", null, "Prêts à donner vie à vos projets ?")
                ], -1)),
                _cache[8] || (_cache[8] = _createElementVNode("p", null, "Faites le premier pas vers une communication d’exception.", -1)),
                _cache[9] || (_cache[9] = _createElementVNode("p", null, "Remplissez le formulaire suivant et discutons de vos ambitions.", -1)),
                (messageError.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[6] || (_cache[6] = [
                      _createElementVNode("p", null, "Une erreur est survenue lors de l'envoi du message. Veuillez réessayer ultérieurement.", -1)
                    ]))]))
                  : _createCommentVNode("", true),
                (Object.keys(validationErrors.value).length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validationErrors.value, (errors, field) => {
                        return (_openBlock(), _createElementBlock("div", { key: field }, [
                          _createElementVNode("p", null, [
                            _createElementVNode("strong", null, _toDisplayString(field === 'name' ? 'Nom' : field === 'message' ? 'Message' : field) + " :", 1)
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errors, (error) => {
                            return (_openBlock(), _createElementBlock("p", { key: error }, _toDisplayString(error), 1))
                          }), 128))
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("form", { onSubmit: submit }, [
                  _createVNode(CommonInput, {
                    name: "contact_name",
                    label: "Nom / Organisation",
                    value: name.value,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
                    invalid: "Veuillez entrer un nom valide.",
                    required: true,
                    disabled: messageSending.value
                  }, null, 8, ["value", "disabled"]),
                  _createVNode(CommonInput, {
                    name: "contact_email",
                    type: "email",
                    label: "Adresse email",
                    value: email.value,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((email).value = $event)),
                    invalid: "Veuillez entrer une adresse email valide.",
                    required: true,
                    disabled: messageSending.value
                  }, null, 8, ["value", "disabled"]),
                  _createVNode(CommonInput, {
                    name: "contact_message",
                    type: "area",
                    label: "Message",
                    value: message.value,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((message).value = $event)),
                    invalid: "Veuillez entrer un message.",
                    required: true,
                    disabled: messageSending.value
                  }, null, 8, ["value", "disabled"]),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "website",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((honeypot).value = $event)),
                    style: {"position":"absolute","left":"-9999px","opacity":"0","pointer-events":"none"},
                    tabindex: "-1",
                    autocomplete: "off",
                    "aria-hidden": "true"
                  }, null, 512), [
                    [_vModelText, honeypot.value]
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(CommonButton, {
                      loading: messageSending.value,
                      icon: "send",
                      type: "submit"
                    }, {
                      default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                        _createTextVNode("Envoyer", -1)
                      ]))]),
                      _: 1
                    }, 8, ["loading"])
                  ])
                ], 32)
              ])
            ]))
      ])
    ])
  ]))
}
}

})